import request from '@/utils/request';
import Resource from '@/api/resource';

class DmpResource extends Resource {
  constructor() {
    super('dmp/jrtt');
  }

  // 获取人群包
  getApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'get',
      params: data,
    });
  }

  // 同步人群包
  pullPackageApi(data) {
    return request({
      url: `/${this.uri}/pull`,
      method: 'GET',
      params: data,
    });
  }

  // 删除人群包
  deleteApi(data) {
    return request({
      url: `/${this.uri}/delete`,
      method: 'post',
      data,
    });
  }

  // 推送人群包
  pushApi(data) {
    return request({
      url: `/${this.uri}/push`,
      method: 'post',
      data,
    });
  }
  // 运算人群包接口
  mergeApi(data) {
    return request({
      url: `/${this.uri}/calc`,
      method: 'post',
      data,
    });
  }
  // 拓展人群包接口
  extendApi(data) {
    return request({
      url: `/${this.uri}/lookAlike`,
      method: 'post',
      data,
    });
  }
  // 创建
  creatApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'post',
      data,
    });
  }
}

export { DmpResource as default };
